export enum Permissoes {
  VIEW_NETWORKING = 'visualizar-Networking',
  EDIT_NETWORKING = 'alterar-networking',
  EDIT_SCORE_NETWORKING = 'alterar-nota-networking',
}
